import React from 'react';
import { Card } from "../../../components";
import { Progress } from "../../../components/progress";
import { Row } from "../../../components/row";
import { Activity } from "lucide-react";

interface SummaryCardProps {
    title: string;
    countEventActives?: number;
    countEventAttendees?: number;
    eventAttendeeColor?: string;
    icon: React.ReactNode;
    iconColor?: string;
    iconBgColor?: string;
    titleColor?: string;
    valueColor?: string;
    bgFrom?: string;
    bgTo?: string;
    borderColor?: string;
}

const SummaryCard: React.FC<SummaryCardProps> = ({
    title,
    countEventActives,
    countEventAttendees,
    eventAttendeeColor,
    icon,
    // iconColor = "white",
    // iconBgColor = "#4E80EE",
    // titleColor = "#4A5565",
    // valueColor = "#4E80EE",
    // bgFrom = "white",
    // bgTo = "white",
    // borderColor = "#E6E6E6",
}) => {
    const getAttendeeColor = (count: number | undefined) => {
        const value = count ?? 0;
        if (value < 50) return 'text-[#4E80EE] dark:text-blue-400';
        if (value <= 100) return 'text-[#5EC269] dark:text-green-400';
        if (value <= 150) return 'text-[#9D59EF] dark:text-purple-400';
        if (value <= 200) return 'text-[#E87B35] dark:text-orange-400';
        return 'text-[#DD524C] dark:text-red-400';
    };

    return (
        <Card
            className={`mx-4 mb-3 p-5 border rounded-2xl border-gray-200 bg-white dark:border-gray-700 dark:bg-gray-800`}
        >
            <div className="flex justify-between items-center mb-2">
                <span className="font-nunito font-extrabold text-lg text-gray-900 dark:text-gray-100">{title}</span>
                <div className="">
                    {icon}
                </div>
            </div>

            <div className="text-[#364153] dark:text-gray-300">
                <Activity size={15} className="inline mr-2 text-[#364153] dark:text-gray-400" />
                <span className="text-sm text-[#364153] dark:text-gray-400">{countEventActives} active {(countEventActives || 0) <= 1 ? 'event' : 'events'}</span>
            </div>

            <div className="mt-2">
                <span className={`font-nunito font-extrabold text-[23px] leading-[28px] ${getAttendeeColor(countEventAttendees)}`}>{countEventAttendees}</span>
                <br />
                <span className="text-sm text-[#364153] dark:text-gray-400">total {(countEventAttendees || 0) <= 1 ? 'attendee' : 'attendees'}</span>
            </div>
        </Card>
    );
};

export default SummaryCard;
